import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"

import Crypto from 'crypto-js'
import Cookie from 'js-cookie'
import { v4 as uuidv4 } from 'uuid'

const cookieName = 'xixe'
const encryptionToken = Cookie.get(cookieName) || uuidv4()

Cookie.set(cookieName, encryptionToken, { secure: true, expires: 1 });



Vue.use(Vuex)

const state = {
  verified: null,
  appInfo: null,
  userInfo: null,
  returnUrl: null,
  lastMsg: null,
  resetToken: null,
  opToken: null,
}

const getters = {
  isAuthenticated: (state) => !!state.userInfo,
  isVerified: (state) => state.verified,
  AccessToken: (state) => state.userInfo.AccessToken,
  LastMsg: (state) => state.lastMsg,
  ResetToken: (state) => state.resetToken,
  OpToken: (state) => state.opToken,
  UserInfo: (state) => state.userInfo,
  AppInfo: (state) => state.appInfo,
  ReturnURL: (state) => state.returnUrl,
  RememberMe: () => (Cookie.get('RememberMe') ==='true'),
}

const mutations = {
  setAppInfo(state, info) {
    state.appInfo = info
  },
  setVerified(state, value) {
    state.verified = value
  },
  setUserInfo(state, info) {
    state.userInfo = info
  },
  setLastMsg(state, value) {
    state.lastMsg = value
  },
  setResetToken(state, token) {
    state.resetToken = token
  },
  setOpToken(state, token) {
    state.opToken = token
  },
  setReturnURL(state, url) {
    state.returnUrl = url
  },
  setRememberMe(state, value) {
    Cookie.set('RememberMe', value, { expires: 7 });
  },
  setAllEmpty(state) {
    state.userInfo = null
    state.returnUrl = null
    state.lastMsg = null
    state.resetToken = null
    state.opToken = null
  },
}

const actions = {
  Logout({commit}) {
    commit('setAllEmpty')
  },
}

const vuexLocal = new VuexPersistence({
  key: 'metadata',
  storage: {
    getItem: (key) => {
      const store = window.sessionStorage.getItem(key);
      if (store) {
        try {
          const bytes = Crypto.AES.decrypt(store, encryptionToken);
          return JSON.parse(bytes.toString(Crypto.enc.Utf8));
        } catch (e) {
          window.sessionStorage.removeItem(key);
        }
      }
      return null;
    },
    setItem: (key, value) => {
      const store = Crypto.AES.encrypt(value, encryptionToken).toString();
      return window.sessionStorage.setItem(key, store);
    },
    removeItem: (key) => window.sessionStorage.removeItem(key),
  },
})


export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexLocal.plugin],
})